import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanLoad,
  Route,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { NavController } from '@ionic/angular';
import { Observable, of } from 'rxjs';
import { AccountService } from '../_services/account.service';
import { switchMap, take, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ReverseAuthGuard implements CanLoad {
  constructor(
    private navController: NavController,
    private accountService: AccountService
  ) {}

  private validate(route: Route | ActivatedRouteSnapshot): Observable<boolean> {
    //.log(route);
    // console.log('reverse guard');
    // TODO: Technically we need to use the tokens to login
    //console.log('1');
    return this.accountService.editPageStream.asObservable().pipe(
      switchMap((isEditPage) => {
        //console.log(isEditPage, 'between line');
        if (!isEditPage) {
          // console.log('reverse guard 1');
          return of(null);
        }
        return this.accountService.saveDataStream.asObservable();
      }),
      //tap(() => console.log('coming here')),
      take(1),
      switchMap(() => {
        if (this.accountService.logoutClicked) {
          this.accountService.logoutClicked = false;
          return of(true);
        }
        if (this.accountService.accessToken) {
          //console.log('reverese guard 2');
          // Logged in, redirect to home
          this.navController.navigateForward(['/listing-doc-status'], {
            replaceUrl: true,
          });

          return of(true);
        }
        // Not logged in, allow to activate login
        return of(true);
      })
    );
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.validate(route);
  }

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.validate(route);
  }
}
